/* eslint-disable react/forbid-component-props */
import React, { useState, useEffect } from 'react'
import { Container, Typography, Box, LinearProgress } from '@mui/material'
import { Link as NavigateLink, Link } from 'react-router-dom'
import GuideLayout from './GuideLayout'
import { useAuth } from '../../../contexts/AuthContext'
import ManagingCanineBehaviour from './Pages/ManagingCanineBehaviour'

const Behaviour = () => {
  const [loading, setLoading] = useState(true)
  const [user, setUser] = useState(null)
  const { currentUser } = useAuth()

  useEffect(() => {
    setUser(currentUser)
    setLoading(false)
  }, [currentUser])

  return (
    <section>
      <Container fixed sx={{ marginTop: '50px' }}>
        <Typography mb={6} variant="h4">
          Training Guide
        </Typography>
        <NavigateLink to="/members">{'< Back to Members Area'}</NavigateLink>
        <Box sx={{ marginTop: 5 }}>
          {!!loading && <LinearProgress color="primary" />}
          <GuideLayout
            watermark={`Licensed to ${user?.firstName} ${user?.lastName}`}
          >
            <Box>
              <Typography align="center" mb={3}>
                PADs In Training Guide
              </Typography>
              <Typography variant="h4" align="center" mb={3}>
                Table of Contents
              </Typography>

              <Box
                component="ul"
                sx={{ pl: 3, listStyle: 'none', p: 0, m: 0, mb: 5 }}
              >
                <li style={{ listStyle: 'none', marginBottom: 10 }}>
                  <a href="#managing-behaviour">5. Managing Canine Behaviour</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#unwanted-behaviour">
                    Understanding the Causes of Unwanted Canine Behaviour
                  </a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#undesirable-behaviour">
                    Undesirable Behaviour in Assistance Dogs
                  </a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#pulling">Pulling on the lead</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#barking">Barking</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#scent-marking">Scent Marking</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#growling">Growling</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#fears">Fears and Anxieties</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#repetitive">Repetitive Behaviours</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#travel">Travel Problems</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#stress">Stress and Behaviour</a>
                </li>
              </Box>
            </Box>
            <ManagingCanineBehaviour />
          </GuideLayout>
        </Box>
      </Container>
    </section>
  )
}

export default Behaviour
